export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium text-accent-600 tracking-wider uppercase mb-3 whitespace-nowrap">
            Featured
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
            焦点专题
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="lg:col-span-2 bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-300/60 cursor-pointer">
            <div className="flex flex-col md:flex-row h-full">
              <div className="md:w-1/2 aspect-video md:aspect-auto md:h-full min-h-[200px] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Bold%20editorial%20illustration%20of%20a%20breaking%20news%20scene%2C%20dramatic%20red%20and%20dark%20tones%2C%20paparazzi%20camera%20flash%20abstract%2C%20entertainment%20scandal%20vibe%2C%20pop%20art%20style%20with%20ben-day%20dots%2C%20megaphone%20and%20headline%20motifs%2C%20warm%20crimson%20accents%2C%20no%20text%2C%20clean%20modern%20composition&width=800&height=500&seq=mrds-carousel-01&orientation=landscape"
                  alt="七月吃瓜特辑：年度十大名场面深度复盘"
                  className="w-full h-full object-cover object-center"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
              </div>
              <div className="md:w-1/2 p-5 md:p-6 flex flex-col justify-center">
                <span className="inline-block text-xs text-primary-500 font-medium mb-2 whitespace-nowrap">重磅专题</span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-3">
                  七月吃瓜特辑：年度十大名场面深度复盘
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  从娱乐圈到网红圈，从综艺舞台到社交平台，这个七月发生了太多值得铭记的吃瓜名场面。我们为你一一梳理，带你重温那些让人拍案惊奇的瞬间。
                </p>
                <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="whitespace-nowrap">更新于 3小时前</span>
                  <span className="whitespace-nowrap">·</span>
                  <span className="whitespace-nowrap">156万 阅读</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-accent-300/60 cursor-pointer">
            <div className="aspect-video overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20celebrity%20rivalry%20and%20comparison%2C%20two%20opposing%20silhouettes%20with%20dramatic%20split%20lighting%2C%20warm%20red%20versus%20cool%20tones%2C%20pop%20art%20versus%20style%2C%20ranking%20stars%20floating%2C%20entertainment%20theme%2C%20no%20text%2C%20bold%20graphic%20design&width=640&height=400&seq=mrds-carousel-02&orientation=landscape"
                alt="顶流对决：两大男星商业价值全方位对比"
                className="w-full h-full object-cover object-center"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
            <div className="p-5">
              <span className="inline-block text-xs text-accent-600 font-medium mb-2 whitespace-nowrap">PK专题</span>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                顶流对决：两大男星商业价值全方位对比
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                从代言数量到粉丝粘性，谁才是真正的商业王？
              </p>
            </div>
          </div>

          <div className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-accent-300/60 cursor-pointer">
            <div className="aspect-video overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20investigative%20reporting%20concept%2C%20magnifying%20glass%20over%20documents%2C%20detective%20noir%20style%20with%20warm%20accents%2C%20dramatic%20shadows%2C%20redacted%20paper%20texture%2C%20mystery%20theme%2C%20pop%20art%20aesthetic%2C%20no%20text%2C%20clean%20composition&width=640&height=400&seq=mrds-carousel-03&orientation=landscape"
                alt="圈内深喉：选秀产业链幕后利益链揭秘"
                className="w-full h-full object-cover object-center"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
            <div className="p-5">
              <span className="inline-block text-xs text-primary-500 font-medium mb-2 whitespace-nowrap">深度调查</span>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                圈内深喉：选秀产业链幕后利益链揭秘
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                独家对话三位业内人士，还原选秀节目不为人知的一面。
              </p>
            </div>
          </div>

          <div className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-300/60 cursor-pointer">
            <div className="aspect-video overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20meme%20culture%20and%20internet%20trends%2C%20floating%20emoji%20and%20reaction%20faces%20abstract%2C%20pop%20art%20comic%20style%2C%20vibrant%20red%20and%20gold%20accents%2C%20social%20media%20feed%20visual%2C%20playful%20entertainment%20theme%2C%20no%20text%2C%20clean%20layout&width=640&height=400&seq=mrds-carousel-04&orientation=landscape"
                alt="年度梗王大选：谁是你心中最搞笑艺人"
                className="w-full h-full object-cover object-center"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
            <div className="p-5">
              <span className="inline-block text-xs text-accent-600 font-medium mb-2 whitespace-nowrap">票选专题</span>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                年度梗王大选：谁是你心中最搞笑艺人
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                十六位候选人已就位，全民投票通道正式开启。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2 bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-accent-300/60 cursor-pointer">
            <div className="flex flex-col md:flex-row h-full">
              <div className="md:w-1/2 aspect-video md:aspect-auto md:h-full min-h-[200px] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20social%20media%20drama%20and%20online%20feuds%2C%20split%20screen%20composition%20with%20opposing%20forces%2C%20dramatic%20red%20and%20dark%20color%20scheme%2C%20chat%20bubbles%20and%20post%20icons%2C%20pop%20art%20warhol%20style%2C%20entertainment%20scandal%20theme%2C%20no%20text%2C%20bold%20graphic%20design&width=800&height=500&seq=mrds-carousel-05&orientation=landscape"
                  alt="娱乐圈社交战争：今年最出圈的五场微博互撕"
                  className="w-full h-full object-cover object-center"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
              </div>
              <div className="md:w-1/2 p-5 md:p-6 flex flex-col justify-center">
                <span className="inline-block text-xs text-primary-500 font-medium mb-2 whitespace-nowrap">年度回顾</span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-3">
                  娱乐圈社交战争：今年最出圈的五场微博互撕
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  从隔空喊话到正面硬刚，从阴阳怪气到律师函警告。回顾今年最具话题度的五次明星社交网络交锋，每一场都精彩绝伦，让吃瓜群众大饱眼福。
                </p>
                <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="whitespace-nowrap">更新于 5小时前</span>
                  <span className="whitespace-nowrap">·</span>
                  <span className="whitespace-nowrap">203万 阅读</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}